import { NgModule } from "@angular/core";

import { TabsComponent } from "./tabs.component";
import { TabComponent } from "./tab/tab.component";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { BadgeModule } from "@gridscale/primeng17/badge";
import { SharedModule } from '../../helper/shared.module';
import { A11yLinkDirective } from '../../helper/directives/a11ylink.directive'
import { CountLabelComponent } from "@gridscale/ingrid/elements/count-label";
import { TooltipModule } from '../../elements/tooltip';

@NgModule({
  declarations: [TabsComponent, TabComponent],
  imports: [
    A11yLinkDirective,
    BadgeModule,
    CommonModule,
    CountLabelComponent,
    RouterModule,
    SharedModule,
    TooltipModule,
  ],
  exports: [TabsComponent, TabComponent]
})
export class TabsModule { }
